"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const storyCreateStates_1 = require("./storyCreateStates");
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const Button_1 = __importDefault(require("@mui/material/Button"));
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const [compressImg, setCompressImg] = (0, recoil_1.useRecoilState)(storyCreateStates_1.storyCreateFileState);
    const [changeImg, setChangeImg] = (0, react_1.useState)(false);
    const { thumbnail } = (0, recoil_1.useRecoilValue)(storyCreateStates_1.storyDataState);
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const { t } = (0, react_i18next_1.useTranslation)();
    const compress = (imageFile) => {
        (0, functions_1.compressImageFile)({
            imageFile,
            maxWidth: 300,
            quality: 0.7,
            onCompressSuccess: (compressedFile) => {
                setCompressImg(compressedFile);
                setChangeImg(true);
            },
        });
    };
    const imgPreview = () => {
        //! 수정시 썸네일 있으면은 썸네일 보내주고
        //! 만약 썸네일 수정했으면은 compressImg 보여주기
        if (!changeImg) {
            if (thumbnail)
                return (0, functions_1.getCdnUrl)(thumbnail);
        }
        else {
            if (compressImg)
                return URL.createObjectURL(compressImg);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(MainPhotoWrapper, { children: [(0, jsx_runtime_1.jsxs)("span", Object.assign({ id: "title" }, { children: [t('대표 이미지'), (0, jsx_runtime_1.jsx)("span", Object.assign({ id: "asterisk" }, { children: "*" }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    position: 'relative',
                    flexShrink: 0,
                    width: 182,
                    height: 136,
                    overflow: 'hidden',
                    borderRadius: '15px',
                    isolation: 'isolate',
                    '&:after': (0, functions_1.afterImgWrapper)({ borderRadius: '15px' }),
                } }, { children: [(0, jsx_runtime_1.jsx)("img", { src: imgPreview() || `${process.env.CDN_URL}/story/background/story_background_default.webp`, css: {
                            width: '100%',
                            height: '100%',
                            borderRadius: '15px',
                            objectFit: 'cover',
                        } }), (0, jsx_runtime_1.jsx)("div", Object.assign({ id: "register_btn_div" }, { children: (0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ component: "label" }, { children: [t('등록'), (0, jsx_runtime_1.jsx)(svgs_1.CameraIconWhiteSvg, { css: { width: '16px', height: '16px' } }), (0, jsx_runtime_1.jsx)("input", { id: "story_photo_input", name: "file", type: "file", hidden: true, onChange: e => e.target.files && compress(e.target.files[0]), onClick: e => {
                                        (0, webview_app_1.askPhotoPermissionsToWVA)('story_photo_input', e);
                                        e.currentTarget.value = '';
                                    } })] })) }))] }))] }));
}
exports.default = default_1;
const MainPhotoWrapper = styled_1.default.div `
  position: relative;
  width: 100%;
  padding: 16px;
  margin-bottom: 10px;
  background-color: #fff;
  #register_btn_div {
    position: absolute;
    top: 50%;
    left: 50%;
    label {
      left: -50%;
      height: 40px;
      padding: 6px 16px;
      border: 0.5px solid rgba(255, 255, 255, 0.7);
      border-radius: 100px;
      margin-top: -20px;
      background: rgba(0, 0, 0, 0.5);
      color: white;
      font-size: 16px;
      line-height: 16px;
      svg {
        margin-left: 10px;
      }
    }
  }
  #title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 18px;
  }
  #asterisk {
    margin-left: 2px;
    color: red;
    font-weight: normal;
  }
`;
